import { ChangeDetectionStrategy, Component, inject, input, Signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { PlatformWidgetComponent } from '../platform-widget.component';
import { MarkantElementsModule } from '@markant/elements-angular';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { CartridgeVariant } from '@markant-platform/cartridge/model';
import { switchMap } from 'rxjs';
import { CartridgesFacade } from '@markant-platform/cartridge/data-access';
import { Router } from '@angular/router';
import { SimpleWidgetWithActionComponent } from '../simple-widget-with-action/simple-widget-with-action.component';

@Component({
  selector: 'markant-platform-reassign-service-roles-widget',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, MarkantElementsModule, SimpleWidgetWithActionComponent],
  templateUrl: './reassign-service-roles-widget.component.html',
  styleUrl: './reassign-service-roles-widget.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReassignServiceRolesWidgetComponent extends PlatformWidgetComponent {
  private cartridgesFacade = inject(CartridgesFacade);
  router = inject(Router);
  translocoService = inject(TranslocoService);
  cartridgeId = input.required<string>();
  buttonConfig: { label: string; action: () => void } = {
    label: this.translocoService.translate('platformWidget.reassignServiceRoles.button'),
    action: this.goToMyServices.bind(this),
  };

  serviceVariant = this.createServiceVariantSignal();

  private createServiceVariantSignal(): Signal<CartridgeVariant | undefined> {
    return toSignal<CartridgeVariant | undefined>(
      toObservable(this.cartridgeId).pipe(switchMap(id => this.cartridgesFacade.cartridgeVariantById$(id)))
    );
  }

  async goToMyServices(): Promise<void> {
    try {
      await this.router.navigateByUrl('/organization/members');
    } catch (error) {
      console.error('Navigation to Organization Members failed:', error);
    }
  }
}
